import $ from 'jquery'
import Blacklight from "../blacklight";
import setupCombineFields from '../combine_fields'

function initializeHarmfulContentForm() {
    setupCombineFields()
}

Blacklight.onLoad(initializeHarmfulContentForm);
initializeHarmfulContentForm();
